//import { } from './radio.styled';

export function Radio(props) {
  return <input type="radio" {...props} />;
}

export default Radio;
